// Browser-only random selections. Never strategy signals or issuance records.
const COUNTS=Object.freeze([5,10,20,25,30,50,100]);
const GAMES=Object.freeze([{id:'pick3',name:'Pick 3',digits:3},{id:'pick4',name:'Pick 4',digits:4},{id:'pick5',name:'Pick 5',digits:5}]);
const {SUPPORTED_STATES}=require('./todaysPicksLaunchConfig');
const STATES=Object.freeze(SUPPORTED_STATES.filter(([id])=>id==='FL'));
function generateQuickPicks(game,count,draw){
 const config=GAMES.find(g=>g.id===game);
 if(!config||!COUNTS.includes(count)||typeof draw!=='function')throw Error('Unsupported Quick Picks request');
 const numbers=new Set();
 // Bound retries even if a broken generator returns the same number forever.
 for(let attempts=0;numbers.size<count&&attempts<count*20;attempts++){
  const digits=draw(game);
  if(!Array.isArray(digits)||digits.length!==config.digits||digits.some(d=>!Number.isInteger(d)||d<0||d>9))throw Error('Invalid Quick Pick generator output');
  numbers.add(digits.join(''));
 }
 if(numbers.size!==count)throw Error('Unable to generate a unique set. Please try again.');
 return [...numbers];
}
function copyText(numbers){return numbers.join('\n');}
module.exports={COUNTS,GAMES,STATES,generateQuickPicks,copyText};
